var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fragment",
    [
      _vm._l(_vm.actionArguments, function (arg) {
        return [
          _c(
            "div",
            {
              key: "arguments-label-" + arg.type + "-" + arg.id,
              staticClass: "label",
            },
            [_vm._v("\n      " + _vm._s(arg.name) + "  \n    ")]
          ),
          _vm._v(" "),
          _c(
            _vm.typeToComponent(arg.type, _vm.readOnly, _vm.action),
            _vm._b(
              {
                key: "arguments-component-" + arg.id,
                ref: "component",
                refInFor: true,
                tag: "component",
                attrs: {
                  title: _vm.value.title,
                  value: _vm.value[arg.id],
                  trigger: _vm.trigger,
                  "read-only": _vm.readOnly,
                  editing: _vm.editing,
                },
                on: {
                  input: function ($event) {
                    return _vm.handleInput($event, arg.id)
                  },
                },
              },
              "component",
              _vm.componentProps(arg),
              false
            )
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }